import React from "react";
import MeetingCatalog from "./MeetingCatalog/MeetingCatalog"
import CatalogProducts from "./CatalogProducts/CatalogProducts";
import classes from "./Products.module.css"

const Products = () => {
    return (
        <div className={classes.Products}>
            <a href="#productsCatalog"><MeetingCatalog/></a>
            <span id="productsCatalog"><CatalogProducts/></span>
    
        </div>
    )
}

export default Products